import { ProjectChangesDateLog } from '../../../domain/projectChangesDateLog/projectChangesDateLog';
import { getProjectChangesDateLogListAdapter } from '../../adapters/project-changes-date-log/projectChangesDateLogAdapter';
import { ProjectChangesListDTO } from '../../http/dtos/project-changes-date-log/projectChangesListDTO';
import httpClient from '../../http/httpClient';

export const ProjectChangesDateLogRepository = {
    GetProjectChangesDateLogList: (id: string) => {
        return httpClient
            .get('/project-changes/project-states-list/' + id)
            .then((response: ProjectChangesListDTO[]) =>
                getProjectChangesDateLogListAdapter(response)
            );
    },

    CreateProjectChangesDateLogFromForm: (formData: FormData, id: string) => {
        return httpClient
            .post('/project-changes/create-project-changes-form/' + id, formData)
            .then((response) => response);
    },

    CreateProjectChangesDateLogFromBody: (
        projectChangesDateLog: ProjectChangesDateLog,
        id: string
    ) => {
        return httpClient
            .post(
                '/project-changes/create-project-changes-body/' + id,
                projectChangesDateLog
            )
            .then((response) => response);
    },
};
